import React from 'react'
import { Box, Link } from 'theme-ui'

import Type from 'src/components/gel/Type'
import { deUrlifyText, urlifyText } from 'src/lib/formatting'
import { defaultClickEvent } from 'src/lib/analytics'

import type { BackgroundColorTypes } from 'src/theme/adSales/colors'

export interface BreadcrumbItem {
  name?: string | null
  link?: string
}

const formatBreadcrumbText = (name: string) => deUrlifyText(name.replaceAll('bbc', 'BBC'))

const Breadcrumb = ({
  crumbs,
  textColor,
  backgroundColor
}: {
  crumbs?: BreadcrumbItem[]
  textColor?: string
  backgroundColor?: BackgroundColorTypes
}) => {
  const linkVariant = textColor
    ? textColor.split('colors.')[1]
    : backgroundColor === 'background.primary'
    ? 'tertiary'
    : 'secondary'
  return (
    <Type
      variant="MetaData"
      sx={{
        py: 4,
        px: [2, null, 4],
        color:
          textColor || backgroundColor === 'background.primary'
            ? 'text.quaternary'
            : 'text.secondary'
      }}
    >
      <Link
        href={'/'}
        variant={linkVariant}
        onClick={() => {
          defaultClickEvent({
            event_grouping: 'Breadcrumbs',
            item_type: 'link',
            item_name: 'Home',
            item_link: '/'
          })
        }}
      >
        <Box as="span">Home</Box>
      </Link>
      {crumbs && (
        <Box as="span" sx={{ mx: [2] }}>
          &gt;
        </Box>
      )}
      {crumbs?.map((crumb, i) =>
        i < crumbs.length - 1 ? (
          <React.Fragment key={`${i}-${crumb.link}`}>
            <Link
              href={urlifyText(crumb.link || '#')}
              variant={linkVariant}
              onClick={() => {
                defaultClickEvent({
                  event_grouping: 'Breadcrumbs',
                  item_type: 'link',
                  item_name: `${crumb.name}`,
                  item_link: `${crumb.link || '#'}`
                })
              }}
            >
              <Box as={'span'}>{formatBreadcrumbText(crumb.name || '')}</Box>
            </Link>
            <Box as={'span'} sx={{ mx: [2] }}>
              &gt;
            </Box>
          </React.Fragment>
        ) : (
          <Box key={`${i}-${crumb.link}`} as={'span'}>
            {formatBreadcrumbText(crumb.name || '')}
          </Box>
        )
      )}
    </Type>
  )
}

export default Breadcrumb
